export { PropertyTwoCoins } from "./PropertyTwoCoins";
